import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Heading, Spinner, Alert, AlertIcon, Input, Flex } from '@chakra-ui/react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const ViewUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/Users/users`);
        const usersData = response.data.$values || response.data; // Extract the array from the nested structure
        const activeUsers = usersData.filter(user => user.isActive); // Filter active users
        setUsers(Array.isArray(activeUsers) ? activeUsers : []);
      } catch (error) {
        setError('Error fetching users');
        console.error('Error fetching users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const columnDefs = [
    { headerName: 'S.No', valueGetter: 'node.rowIndex + 1', filter: false,width:80 },
    { headerName: 'Username', field: 'username', filter: true, floatingFilter: true },
    { headerName: 'Role', field: 'role', filter: true, floatingFilter: true },
    { headerName: 'Name', field: 'userinfo.name', filter: true, floatingFilter: true },
    { headerName: 'Email', field: 'userinfo.email', filter: true, floatingFilter: true },
    { headerName: 'City', field: 'userinfo.city', filter: true, floatingFilter: true },
    { headerName: 'Designation', field: 'userinfo.designation', filter: true, floatingFilter: true },
    { headerName: 'Department', field: 'userinfo.department', filter: true, floatingFilter: true },
  ];

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    floatingFilter: true
  };

  const onGridReady = params => {
    params.api.sizeColumnsToFit();
  };

  const onFilterTextBoxChanged = event => {
    setSearchText(event.target.value);
  };

  if (loading) {
    return (
      <Box className="flex justify-center items-center h-full">
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box className="flex justify-center items-center h-full">
        <Alert status="error">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box className="p-8">
      <Heading as="h2" size="xl" mb="8">
        View Users
      </Heading>
      <Flex mb="4" justifyContent="space-between" alignItems="center">
        <Input
          placeholder="Search..."
          value={searchText}
          onChange={onFilterTextBoxChanged}
          width="300px"
        />
      </Flex>
      <Box className="ag-theme-alpine" style={{ height: 600, width: '100%' }}>
        <AgGridReact
          rowData={users}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onGridReady={onGridReady}
          quickFilterText={searchText}
          pagination={true}
          paginationPageSize={10}
        />
      </Box>
    </Box>
  );
};

export default ViewUsers;
